import { Cloud, CloudSun, CloudFog, CloudDrizzle, CloudRain, CloudSnow, CloudLightning, Sun, Wind, Droplets, Thermometer } from "lucide-react";

const ICONS = { sun: Sun, cloud: Cloud, "cloud-sun": CloudSun, "cloud-fog": CloudFog, "cloud-drizzle": CloudDrizzle, "cloud-rain": CloudRain, "cloud-snow": CloudSnow, "cloud-lightning": CloudLightning };

export default function WeatherCard({ weather, stadium }) {
  if (!weather) {
    return (
      <div className="surface-raised p-6" data-testid="weather-card">
        <div className="label text-[10px]">Meteo Stadio</div>
        <p className="text-sm text-[#A1A1AA] mt-2">Previsioni non disponibili per questa località.</p>
      </div>
    );
  }
  const Icon = ICONS[weather.icon] || Cloud;
  const place = [stadium.name, stadium.city].filter(Boolean).join(" · ");
  return (
    <div className="surface-raised p-6" data-testid="weather-card">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="label text-[10px]">Meteo al calcio d&apos;inizio</div>
          <div className="heading text-2xl font-black mt-1" data-testid="weather-condition">{weather.condition}</div>
          <div className="text-xs text-[#A1A1AA] mt-1">{place}</div>
        </div>
        <div className="w-14 h-14 border border-[#27272A] grid place-items-center bg-black/40">
          <Icon size={28} strokeWidth={1.3} color={weather.rain_probability > 40 ? "#007AFF" : "#FFCC00"} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Metric icon={Thermometer} label="Temp." value={`${weather.temperature_c}°C`} />
        <Metric icon={CloudRain} label="Pioggia" value={`${weather.rain_probability}%`} hot={weather.rain_probability >= 50} />
        <Metric icon={Wind} label="Vento" value={`${weather.wind_kmh} km/h`} hot={weather.wind_kmh >= 25} />
        <Metric icon={Droplets} label="Umidità" value={`${weather.humidity}%`} />
      </div>
      <div className="mt-3 text-[10px] text-[#71717A] mono">Fonte: {weather.source}</div>
    </div>
  );
}

function Metric({ icon: Icon, label, value, hot }) {
  return (
    <div className="border border-[#27272A] p-3 flex items-center gap-3">
      <Icon size={18} strokeWidth={1.5} color={hot ? "#39FF14" : "#A1A1AA"} />
      <div className="min-w-0">
        <div className="label text-[9px]">{label}</div>
        <div className={`heading text-lg font-black mono ${hot ? "text-[#39FF14]" : "text-white"}`}>{value}</div>
      </div>
    </div>
  );
}
